import { useEffect, useState } from 'react';

import queryString from 'query-string';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Master from '../Layouts/Master';

const MembershipSuccess = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const [params, setParams] = useState({});

  useEffect(() => {
    const queryParams = queryString.parse(search);
    if (!queryParams?.tracking_id) {
      navigate('/', { replace: true });
      return;
    }
    setParams(queryParams);
  }, [search, navigate]);

  const returnPath = params?.return || '/panel/profile/match-registered';

  return (
    <Master title='پرداخت حق عضویت'>
      <div className='row my-5'>
        <div className='col-12 col-md-6 offset-md-3'>
          <div className='bg-white rounded shadow-sm p-4 text-center'>
            <i className='fad fa-check-circle text-success f-90 my-2'></i>
            <h2 className='text-success f-18 font-weight-bold my-3'>
              حق عضویت با موفقیت تمدید شد
            </h2>
            <p className='text-secondary f-14'>
              کد پیگیری: <strong>{params?.tracking_id}</strong>
            </p>
            <Link to={returnPath} className='btn btn-info f-14 px-4 mt-3'>
              ادامه
            </Link>
          </div>
        </div>
      </div>
    </Master>
  );
};

export default MembershipSuccess;
